export default __webpack_public_path__ + "static/media/i_bus-low_pp_tagless.3fca6711.svg";